export function getWorkQAutoRefreshConfig(workq) {
    const autoRefresh = workq?.auto_refresh === true || workq?.auto_refresh === 1
    const refreshAfterMinutes = Math.max(5, Number(workq?.refresh_after) || 5)
    return {
        autoRefresh,
        refreshAfterMs: refreshAfterMinutes * 60 * 1000,
    }
}
